import React from "react";
import Quiz from "../Quiz";

const questions = [
  {
    questionText: "What is the primary function of the CPU?",
    options: [
      "To display images on the screen",
      "To process information and execute instructions",
      "To store data permanently",
      "To connect to the internet",
    ],
    correct: "To process information and execute instructions",
  },
  {
    questionText: "Which device is used to input data into a computer?",
    options: ["Monitor", "Speaker", "Keyboard", "Printer"],
    correct: "Keyboard",
  },
  {
    questionText: "What is ergonomics in computer use?",
    options: [
      "The study of computer hardware",
      "The art of typing quickly",
      "Setting up your computer and body for comfort and safety",
      "A type of computer virus",
    ],
    correct: "Setting up your computer and body for comfort and safety",
  },
  {
    questionText: 'What is the purpose of the "Save As" function in Microsoft Word?',
    options: [
      "To print a document",
      "To close a document",
      "To save a document with a specific name and location",
      "To delete a document",
    ],
    correct: "To save a document with a specific name and location",
  },
  {
    questionText: "Which tab in Microsoft Word contains tools for formatting text?",
    options: ["Home", "Insert", "Page Layout", "Review"],
    correct: "Home",
  },
  {
    questionText: "How can you insert a picture into a Microsoft Word document?",
    options: [
      "Home tab → Fonts",
      "Insert tab → Pictures",
      "Page Layout tab → Margins",
      "Review tab → Spelling",
    ],
    correct: "Insert tab → Pictures",
  },
  {
    questionText: "What is a computer virus?",
    options: [
      "A program that helps your computer run faster",
      "A program that can harm your computer",
      "A type of software that protects your computer",
      "A type of hardware that connects to your computer",
    ],
    correct: "A program that can harm your computer",
  },
  {
    questionText: "How can you protect your computer from viruses?",
    options: [
      "By opening unknown attachments or emails",
      "By using antivirus software and keeping your software updated",
      "By downloading programs from the internet without caution",
      "By sharing your passwords online",
    ],
    correct: "By using antivirus software and keeping your software updated",
  },
  {
    questionText: "What is phishing?",
    options: [
      "A type of computer virus",
      "A fake email or message trying to steal your personal info",
      "A type of spam email",
      "A type of antivirus software",
    ],
    correct: "A fake email or message trying to steal your personal info",
  },
  {
    questionText: "What is the purpose of the Taskbar?",
    options: [
      "To display icons and shortcuts",
      "To show the current time",
      "To access the Start menu",
      "All of the above",
    ],
    correct: "All of the above",
  },
  {
    questionText: 'What is the function of the "Ctrl + S" shortcut?',
    options: ["To copy text", "To paste text", "To save a document", "To print a document"],
    correct: "To save a document",
  },
  {
    questionText: "Why is it important to maintain good posture while using a computer?",
    options: [
      "To improve your typing speed",
      "To reduce eye strain",
      "To prevent back pain and discomfort",
      "To increase your focus",
    ],
    correct: "To prevent back pain and discomfort",
  },
  {
    questionText: "What is spam?",
    options: [
      "A type of computer virus",
      "Unwanted emails, often selling something or including dangerous links",
      "A type of antivirus software",
      "A type of hardware that connects to your computer",
    ],
    correct: "Unwanted emails, often selling something or including dangerous links",
  },
  {
    questionText: "How can you deal with hoaxes and spam?",
    options: [
      "By clicking on suspicious links",
      "By using spam filters and being cautious online",
      "By sharing your passwords online",
      "By downloading programs from the internet without caution",
    ],
    correct: "By using spam filters and being cautious online",
  },
  {
    questionText: "Why is it important to use antivirus software?",
    options: [
      "To improve your computer's performance",
      "To protect your computer from viruses and malware",
      "To increase your storage space",
      "To connect to the internet",
    ],
    correct: "To protect your computer from viruses and malware",
  },
  {
    questionText: "Why is it important to take breaks while using a computer?",
    options: [
      "To improve your focus",
      "To reduce eye strain and prevent discomfort",
      "To increase your productivity",
      "To access the internet",
    ],
    correct: "To reduce eye strain and prevent discomfort",
  },
  {
    questionText: "What is the primary function of a keyboard?",
    options: [
      "To display images on the screen",
      "To input data into a computer",
      "To store data permanently",
      "To connect to the internet",
    ],
    correct: "To input data into a computer",
  },
  {
    questionText: "Why is it important to save your work regularly?",
    options: [
      "To prevent data loss due to power failure or computer crash",
      "To increase your storage space",
      "To improve your computer's performance",
      "To connect to the internet",
    ],
    correct: "To prevent data loss due to power failure or computer crash",
  },
  {
    questionText: "How can you protect your personal info online?",
    options: [
      "By sharing your passwords with friends",
      "By using strong and unique passwords",
      "By clicking on suspicious links",
      "By downloading programs from unknown sources",
    ],
    correct: "By using strong and unique passwords",
  },
  {
    questionText: 'What is the purpose of the "Ctrl + C" shortcut?',
    options: ["To paste text", "To copy text", "To cut text", "To save a document"],
    correct: "To copy text",
  },
  {
    questionText: 'What is the purpose of the "Recycle Bin" icon on the desktop?',
    options: [
      "To store frequently used files",
      "To delete files permanently",
      "To temporarily store deleted files",
      "To access the Start menu",
    ],
    correct: "To temporarily store deleted files",
  },
  {
    questionText: "Why is it important to be cautious when downloading programs from the internet?",
    options: [
      "To prevent data loss",
      "To protect your computer from viruses and malware",
      "To increase your storage space",
      "To improve your computer's performance",
    ],
    correct: "To protect your computer from viruses and malware",
  },
  {
    questionText: "What is the purpose of antivirus software?",
    options: [
      "To improve your computer's performance",
      "To protect your computer from viruses and malware",
      "To increase your storage space",
      "To connect to the internet",
    ],
    correct: "To protect your computer from viruses and malware",
  },
];

export default function ComputerSkillsQuiz({ studentInfo, onComplete }) {
  return <Quiz studentInfo={studentInfo} questions={questions} onComplete={onComplete} />;
}
